import { fromJS } from 'immutable';

import { SETUP } from './constants';

export const initialState = fromJS({
  config: fromJS({}),
});

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case SETUP: {
      const { mediaFilesPrefix } = action.payload.data;

      // TODO: префикс не передается
      return state
        .setIn(['config', 'mediaFilesPrefix'], mediaFilesPrefix);
    }

    default:
      return state;
  }
}
